import React, { useEffect, useRef, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { InputSwitch } from "primereact/inputswitch";
import { MultiSelect } from "primereact/multiselect";
import { RefreshCw, Activity } from "lucide-react";
import { useWarehouseTaskStore } from "../../store/warehouseTask";
import { DateRangePicker } from "../DateRangePicker";

export const ReportFilterBar = ({
  filters,
  onFilterChange,
  loading,
  onRefresh,
}: any) => {
  const taskStore = useWarehouseTaskStore();
  const [staffOptions, setStaffOptions] = useState([]);
  const intervalRef = useRef<any>(null);
  const getTodayRange = () => {
    const start = new Date();
    start.setHours(0, 0, 0, 0);

    const end = new Date();
    end.setHours(23, 59, 59, 999);

    return {
      startDate: toLocalISOString(start),
      endDate: toLocalISOStringEnd(end),
    };
  };
  useEffect(() => {
    taskStore.getStaffList().then(setStaffOptions);
  }, []);

  const toLocalISOString = (date: Date | null) => {
    if (!date) return null;
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}T00:00:00.000Z`;
  };

  const toLocalISOStringEnd = (date: Date | null) => {
    if (!date) return null;
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}T23:59:59.999Z`;
  };

  useEffect(() => {
    if (!filters.isLiveActive) return;

    const todayStart = new Date();
    todayStart.setHours(0, 0, 0, 0);

    const todayEnd = new Date();
    todayEnd.setHours(23, 59, 59, 999);

    onFilterChange((prev: any) => ({
      ...prev,
      dateRange: [todayStart, todayEnd],
    }));

    const interval = setInterval(() => {
      onRefresh?.();
    }, 5000);

    return () => clearInterval(interval);
  }, [filters.isLiveActive]);

return (
    <div className="w-full card2 border border-borderColor/30 rounded-2xl p-2 flex flex-wrap items-center gap-2">
      
      {/* 1. DATE PICKER - Esnek, en solda, tam genişlik alabilir */}
      <div className="flex-1 min-w-[280px]">
        <DateRangePicker
          value={filters.dateRange}
          onChange={(dates) => {
            onFilterChange({
              ...filters,
              dateRange: dates,
              isLiveActive: false,
            });
          }}
        />
      </div>

      {/* 2. OPERATION - Sabit genişlik veya küçük esneklik */}
      <div className="w-full sm:w-40">
        <Dropdown
          className="w-full h-9 flex items-center"
          value={filters.operationType}
          options={[
            { label: "Tüm Aşamalar", value: "ALL" },
            { label: "Sadece Toplama", value: "PICK" },
            { label: "Sadece Paketleme", value: "PACK" },
          ]}
          onChange={(e) => onFilterChange({ ...filters, operationType: e.value })}
        />
      </div>

      {/* 3. STAFF - MultiSelect genellikle daha fazla yer ister */}
      <div className="w-full sm:flex-1 min-w-[200px]">
        <MultiSelect
          className="w-full h-9 flex items-center"
          value={filters.userIds || []}
          options={staffOptions}
          onChange={(e) => onFilterChange({ ...filters, userIds: e.value })}
          placeholder="Personel"
          emptyMessage="Kayıt Bulunamadı"
          filter
          showClear
        />
      </div>

      {/* 4. TOOLS (Live + Refresh) - Sağ tarafta gruplandırılmış */}
      <div className="flex items-center gap-2 ml-auto">
        <div className="flex items-center gap-2 px-3 h-9 card rounded-xl border border-borderColor/20">
          <Activity
            size={14}
            className={filters.isLiveActive ? "text-green-500 animate-pulse" : "text-gray-400"}
          />
          <span className="text-xs font-semibold whitespace-nowrap">Canlı</span>
          <InputSwitch
            checked={filters.isLiveActive}
            onChange={(e) => {
              const isLive = e.value;
              const today = getTodayRange();
              onFilterChange({
                ...filters,
                isLiveActive: isLive,
                dateRange: null,
                startDate: today.startDate,
                endDate: today.endDate,
              });
            }}
          />
        </div>

        <button
          onClick={onRefresh}
          disabled={loading}
          className="h-9 w-9 flex items-center justify-center rounded-xl border border-borderColor/30 hover:bg-gray-50 transition-colors"
        >
          <RefreshCw className={loading ? "animate-spin" : ""} size={16} />
        </button>
      </div>
    </div>
  );
};